import React, { useState } from "react";
import { AiOutlineInstagram } from "react-icons/ai";
import { CiTwitter } from "react-icons/ci";
import { BsFacebook } from "react-icons/bs";
import { BsYoutube } from "react-icons/bs";
import { BiPhoneCall } from "react-icons/bi";
import { FiMail } from "react-icons/fi";
import { GoLocation } from "react-icons/go";
import { RiTaskFill } from "react-icons/ri";
import ContactModel from "./models/ContactModel";
import { Link } from "react-router-dom";
export default function Footer({ Contactref }) {
  const [istoogle, setistoogle] = useState(false);

  const Tooglemodel = () => {
    setistoogle(true);
  };

  const Mail = () => {
    window.location.href = "mailto:mediatechmarketing25@gmail.com";
  };

  return (
    <>
      <div className="py-32" ref={Contactref}>
        <div className="flex items-center justify-center space-x-5">
          <div className="p-3 border-2 border-red-500 rounded-full">
            <Link to="https://twitter.com/_SaaS_Studio">
              <CiTwitter size={28} color="white" cursor={"pointer"} />
            </Link>
          </div>
        </div>
        <div className="my-8 space-y-10 text-center text-white">
          <h1 className="text-2xl font-bold md:text-5xl">
            Have any project in mind?
          </h1>
          <button
            onClick={Tooglemodel}
            className="py-4 font-semibold duration-500 ease-in-out border-2 border-red-500 px-7 hover:bg-white hover:border-white hover:text-black"
          >
            MAKE INQUIRE
          </button>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center space-y-6 border-t-2 border-red-500 md:flex-row md:justify-evenly">
        <div className="my-8 text-center text-white space-y-7 md:my-0 md:text-left">
          <h1 className="text-4xl font-bold md:text-5xl">MediaTech</h1>
          <p className="font-semibold md:text-xl">Your Smarter Move</p>
          <div className="border-2 border-red-500 w-[55vw] md:w-[10vw] "></div>
        </div>
        <div className="text-white">
          <h1 className="text-lg font-bold">OUR SERVICES</h1>
          <ul className="my-5 space-y-5 font-bold text-center md:text-left">
            <li className="flex space-x-4">
              <p>Website development</p>
            </li>
            <li className="flex space-x-4">
              <p>App development</p>
            </li>
            <li className="flex space-x-4">
              <p>Content Writing</p>
            </li>
            <li className="flex space-x-4">
              <p>PWA</p>
            </li>
            <li className="flex space-x-4">
              <p>WebApps</p>
            </li>
          </ul>
        </div>
        <div className="text-white">
          <h1 className="text-lg font-semibold">CONTACT US</h1>
          <ul className="my-5 space-y-5">
            <li className="flex space-x-4">
              <BiPhoneCall size={20} color="white" />
              <p>9392895395</p>
            </li>
            <li onClick={Mail} className="flex space-x-4 cursor-pointer">
              <FiMail size={20} color="white" />
              <p>mediatechmarketing25@gmail.com</p>
            </li>
            <li className="flex space-x-4">
              <GoLocation size={20} color="white" />
              <p>Hyderabad India</p>
            </li>
            <li className="flex space-x-4">
              <RiTaskFill size={20} color="white" />
              <p>Monday to Saturday</p>
            </li>
          </ul>
        </div>
      </div>
      {istoogle ? <ContactModel setistoogle={setistoogle} /> : null}
    </>
  );
}
